import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { searchEditRoutes } from '../../tms-shared';
import { RoleComponent, RolesComponent } from './components';

@NgModule({
  imports: [RouterModule.forChild(searchEditRoutes(RolesComponent, RoleComponent))],
  exports: [RouterModule],
})
export class RoleRoutingModule {}
